import { Component, input } from "@angular/core";
import { ControlValueAccessor, FormControl } from "@angular/forms";

import { BaseComponent } from '@base/base.component';
import { StoreService } from "@services/store.service";

export type VzVariant = 'outlined' | 'filled' | 'borderless' | 'underlined';
@Component({
    template: '',
    standalone: false
})
export class BaseControlComponent extends BaseComponent implements ControlValueAccessor {
    vzVariant       = input<VzVariant>('outlined');
    control = new FormControl();
    onChange: any = () => {};
    onTouched: any = () => {};

    constructor(protected _store?: StoreService) {
        super(_store);
        this.control.valueChanges.subscribe(v => {
            this.onChange(v);
        });
    }

    writeValue(obj: any): void {
        this.control.setValue(obj);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        if (isDisabled) {
            this.control.disable();
        }
        else {
            this.control.enable();
        }
    }

}